// extracted by mini-css-extract-plugin
export default {"main-content":"List_main-content__VDpum","list":"List_list__ww3fo","compact":"List_compact__zhCmh"};